$.fn.revealIfActive = function () {
  $(this).each(function () {
    // initialise hide/show Contents
    var requirePair = revealIfActive(this).data("require-pair");
    // bind change event
    $(requirePair).on("change", function (e) {
      $(".reveal-if-active").each(function () {
        // show/hide contents
        revealIfActive(this);
      });
    });
  });

  function revealIfActive(el) {
    var $el = $(el);
    var $requirePair = $($el.data("require-pair"));

    if ($requirePair.is(":checked"))
      $el.slideDown().find("input").prop("disabled", false);
    else $el.slideUp("fast").find("input").prop("disabled", true);

    return $el;
  }
};
